import React, { useState, useEffect, useContext } from "react";
import { GoogleMap, useJsApiLoader, OverlayView } from "@react-google-maps/api";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import apiClient from "../../ApiEndpoint/apiClient";
import apiUrl from "../../ApiEndpoint/config";


const mapContainerStyle = {
  width: "100%",
  height: "350px",
  borderRadius: "10px",
};

const defaultCenter = { lat: 39.50, lng: -98.35 };


let Map = ({ markers }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBUzGu9ytbWBaOeO2peYl5qhZhmp9gPaQY",
  });

  const {
    cityLat,
    cityLng,
    countyLat,
    countyLng,
    stateLat,
    stateLng,
    stateLatBld,
    stateLngBld,
    facLat,
    facLng,
    setStateLat,
    setStateLng,
    setCityLat,
    setCityLng,
    setCountyLat,
    setCountyLng,
    setFacLat,
    setFacLng,
    setRegisterid,
    setViolationData,
    showFilterBar,
    setStateLatBld,
    setStateLngBld,
    cityLatBld,
    cityLngBld,
    setCityLatBld,
    setCityLngBld,
    bldLat,
    setBldLat,
    bldLng,
    setBldLng,
    setStateContext,
    setCountyContext, setCityContext,
    setCountyObjContext,
    setCityObjContext
  } = useContext(RegisterIdContext);

  let defaultIdentifier = showFilterBar ? "FAC_STATE" : "STATE";
  let [locationIdentifier, setLocationIdentifier] = useState(defaultIdentifier);

  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [zoomLevel, setZoomLevel] = useState(4);
  let [hoveredLocation, setHoveredLocation] = useState(null);
  // const [hideTimeout, setHideTimeout] = useState(null);
  // const [showSiteTable, setShowSiteTable] = useState(false);
  const { markerLoc, setMarkerLoc } = useContext(RegisterIdContext);


  useEffect(() => {
    if (showFilterBar) {
      setStateLatBld(null);
      setStateLngBld(null);
      setCityLatBld(null);
      setCityLngBld(null);
      setBldLat(null);
      setBldLng(null);
      setLocationIdentifier("FAC_STATE");
    } else {
      setStateLat(null);
      setStateLng(null);
      setCityLat(null);
      setCityLng(null);
      setCountyLat(null);
      setCountyLng(null);
      setFacLat(null);
      setFacLng(null);
      setLocationIdentifier("STATE");
    }
  }, [showFilterBar]);

  useEffect(() => {
    if (showFilterBar) {
      if (facLat && facLng) {
        const singleMarker = markers[0];
        setZoomLevel(16); // Zoom in on single marker
        setMapCenter({
          lat: singleMarker?.LATITUDE,
          lng: singleMarker?.LONGITUDE,
        });
        setLocationIdentifier("FAC_NAME");
      } else if (cityLat && cityLng) {
        setMapCenter({ lat: cityLat, lng: cityLng });
        setZoomLevel(11);
        setLocationIdentifier("FAC_NAME");
      } else if (countyLat && countyLng) {
        setMapCenter({ lat: countyLat, lng: countyLng });
        setZoomLevel(9);
        setLocationIdentifier("FAC_CITY");
      } else if (stateLat && stateLng) {
        setMapCenter({ lat: stateLat, lng: stateLng });
        setZoomLevel(7);
        setLocationIdentifier("FAC_COUNTY");
      } else {
        setZoomLevel(4.2);
        setLocationIdentifier("FAC_STATE");
        setMapCenter(defaultCenter);
      }
    } else {
      if (bldLat && bldLng) {
        const singleMarker = markers[0];
        setZoomLevel(16); // Zoom in on single marker
        setMapCenter({
          lat: singleMarker?.LATITUDE,
          lng: singleMarker?.LONGITUDE,
        });
        setLocationIdentifier("Master_Building_Name");
      } else if (cityLatBld && cityLngBld) {
        setMapCenter({ lat: cityLatBld, lng: cityLngBld });
        setZoomLevel(12);
        setLocationIdentifier("Master_Building_Name");
      } else if (stateLatBld && stateLngBld) {
        setMapCenter({ lat: stateLatBld, lng: stateLngBld });
        setZoomLevel(7);
        setLocationIdentifier("CITY");
      } else {
        setZoomLevel(4);
        setLocationIdentifier("STATE") // Zoom in on single marker
        setMapCenter(defaultCenter);
      }
    }
  }, [cityLat, cityLng, countyLat, countyLng, stateLat, stateLng, facLat, facLng, markers, stateLatBld, stateLngBld, cityLatBld, cityLngBld]);





  // Handle state selection
  if (!isLoaded) return <div>Loading Map...</div>;

  // Handle onclick selection
  const updateMarkerLoc = async (loc) => {
    if (loc?.FAC_CITY) {
      const cityvalue = {
        state_code: loc?.STATE,
        city: loc?.FAC_CITY,
        county: loc?.COUNTY,
        city_latitude: loc?.LATITUDE,
        city_longitude: loc?.LONGITUDE
      }
      setCityObjContext(cityvalue)
      setCityContext(loc?.FAC_CITY)
    } else if (loc?.FAC_COUNTY) {
      const countyvalue = {
        state: loc.STATE,
        county: loc.FAC_COUNTY,
        county_latitude: loc.LATITUDE,
        county_longitude: loc.LONGITUDE
      };
      setCountyObjContext(countyvalue)
      setCountyContext(loc?.FAC_COUNTY)
    } else if (loc?.FAC_STATE) {
      setStateContext(loc?.FAC_STATE)
    } else if (loc?.STATE) {
      setStateContext(loc?.STATE)
    } else if (loc?.CITY) {
      const cityvalue = {
        state_code: loc?.state_code,
        city: loc?.CITY,
        city_latitude: loc?.LATITUDE,
        city_longitude: loc?.LONGITUDE
      }
      setCityObjContext(cityvalue)
      setCityContext(loc?.CITY)
    }




    setMarkerLoc(loc?.REGISTRY_ID)
    if (loc?.REGISTRY_ID) {
      const facilityResponse = await apiClient.get(`${apiUrl}/facility_info?registry_id=${loc?.REGISTRY_ID}`);
      const facilityData = facilityResponse.data?.data || [];
      setRegisterid(facilityData);
      const violationResponse = await apiClient.get(`${apiUrl}/npdes_facility_violations?registry_id=${loc?.REGISTRY_ID}`);
      const violationData = violationResponse.data ? violationResponse.data : null; // Set to null if undefined
      setViolationData(violationData)
    }

  };

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={mapCenter}
      zoom={zoomLevel}
      mapTypeId="hybrid"
    >
      {markers.map(
        (loc, index) => (
          (
            <OverlayView
              key={index}
              position={{ lat: loc.LATITUDE, lng: loc.LONGITUDE }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} // Ensures the icon can receive click events
            >
              <div
                style={{
                  // position: "relative",
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                }}
                onClick={() => updateMarkerLoc(loc)}
                onMouseEnter={() => setHoveredLocation(loc)}
                onMouseLeave={() => setHoveredLocation(null)}
              >
                <img
                  src={
                    typeof loc.IS_VEOLIA_SITE !== "undefined" &&
                      loc.IS_VEOLIA_SITE
                      ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
                      : loc.VEOLIA_SITE_COUNT > 0
                        ? "https://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                        : "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                  }
                  alt="Marker"
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </OverlayView>
          )
        )
      )}
      {hoveredLocation && (
        <OverlayView
          position={{
            lat: hoveredLocation.LATITUDE,
            lng: hoveredLocation.LONGITUDE,
          }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div
            style={{
              position: "absolute",
              transform: "translate(-50%, -120%)",
              background: "white",
              color: "black",
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "12px",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
              whiteSpace: "nowrap",
              zIndex: 1000,
              textAlign: "center",
              maxWidth: "350px",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "13px",
                marginBottom: "2px",
              }}
            >
              {hoveredLocation[locationIdentifier] || "Location"}
            </div>
            {hoveredLocation.FACILITY_COUNT && (
              <div style={{ fontSize: "12px" }}>
                Facility Count: {hoveredLocation.FACILITY_COUNT || 0}
              </div>
            )}
            {hoveredLocation.BUILDING_COUNT && (
              <div style={{ fontSize: "12px" }}>
                Building Count: {hoveredLocation.BUILDING_COUNT || 0}
              </div>
            )}
          </div>
        </OverlayView>
      )}
    </GoogleMap>
  );
};

export default Map;



